module.exports = __webpack_public_path__ + "img/05.d1e40ed5.jpg";